export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_1-7a6f02e26c800629272650a5350feb32.jpg";